<template>
  <!-- that outer div wrapper is important -->
  <div>
    <button class="new-field-button">
      <BaseIcon class="new-field-button__ico-plus" name="circle-plus"/>
      <div>
        {{ title }}
        <strong v-if="titleStrong">
          {{ titleStrong }}
        </strong>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    title: { default: 'Add a field' },
    titleStrong: String,
    data: Object,
    store: Object
  },
  methods: {
    parentLabel () {
      return this.data ? this.data.label : null
    }
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/breakpoints.scss';

  .new-field-button {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    background-color: $color-whisper;
    border: 1px solid $color-border;
    border-radius: 0 0 3px 3px; 
    margin-top: -1px;
    margin-right: -1px;
    color: $color-purple;
    font-size: 14.6px;
    text-align: left;

    &:hover {
      @include media(hover) {
        background-color: $color-purple;
        color: #fff;
      }
    }

    &:focus {
      background-color: $color-purple;
      color: #fff;
    }

    strong {
      font-weight: 700;
    }

    &__ico-plus {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      margin-right: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewFieldButton.vue